import BackgroundImageSwitcher from './BackgroundImageSwitcher'
import backgroundImageSwitcherContainer from './backgroundImageSwitcherContainer'

export default backgroundImageSwitcherContainer(BackgroundImageSwitcher)
